import { useState, useEffect } from 'react';

const useClientSize = (ref) => {
  const [clientWidth, setClientWidth] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  useEffect(() => {
    const getSize = () => {
      if (!ref.current) {
        return;
      }
      setClientWidth(ref.current.clientWidth);
      setClientHeight(ref.current.clientHeight);
    };
    getSize();
    window.addEventListener("resize", getSize);
    return () => window.removeEventListener("resize", getSize);
  }, [ref]);
  return { clientWidth, clientHeight };
};

export { useClientSize };
//# sourceMappingURL=useClientSize.js.map
